(() => {
  const openers = new WeakMap();
  const hydrationKey = 'rootix-hydration-seen-v2';
  const visitKey = 'rootix-info-shown-v2';
  let automaticShown = false;
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  function open(dialog, source) {
    if (!dialog || dialog.open || !dialog.isConnected) return;
    openers.set(dialog, source || document.activeElement);
    dialog.showModal();
    dialog.scrollTop = 0;
    if (dialog.matches('[data-hydration-dialog]')) {
      if (!window.Shopify?.designMode) {
        write('localStorage', hydrationKey, String(Date.now()));
        write('sessionStorage', visitKey, '1');
      }
      automaticShown = true;
    }
  }
  function blocked() {
    const visible = el => {
      if (el.closest('details:not([open]), [hidden], [aria-hidden="true"]')) return false;
      const style = getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' &&
        style.display !== 'none' && Number(style.opacity) > 0;
    };
    return document.hidden || [...document.querySelectorAll('dialog[open], cart-drawer.active, cart-notification.active, header details[open], .menu-drawer-container[open], #shopify-pc__banner, [role="dialog"][aria-modal="true"]')].some(visible);
  }
  function schedule(dialog, key) {
    if (window.Shopify?.designMode || automaticShown || read('sessionStorage', visitKey)) return;
    const cooldown = (Number(dialog.dataset.cooldown) || 7) * 86400000;
    if (Date.now() - Number(read('localStorage', key) || 0) < cooldown) return;
    let attempts = 0;
    const tryOpen = () => {
      if (!dialog.isConnected || automaticShown || read('sessionStorage', visitKey)) return;
      if (blocked()) { if (++attempts < 120) setTimeout(tryOpen, 1000); return; }
      open(dialog);
      automaticShown = true;
      write('sessionStorage', visitKey, '1');
    };
    setTimeout(tryOpen, Number(dialog.dataset.delay) || 7000);
  }
  function init() {
    document.querySelectorAll('dialog[data-hydration-dialog], dialog[data-drop-dialog], #RootixContact').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', () => {
        const opener = openers.get(dialog);
        if (opener?.isConnected) opener.focus();
        if (dialog.matches('[data-drop-dialog]')) write('localStorage', 'rootix-drop-closed', String(Date.now()));
      });
      if (dialog.querySelector('[data-newsletter-success], [data-newsletter-error], [data-contact-success], [data-contact-error]')) open(dialog);
    });
    const hydration = document.querySelector('[data-hydration-dialog]');
    const newsletter = document.querySelector('[data-drop-dialog]');
    // Prefer the educational popup; one automatic popup per visit.
    if (hydration && hydration.dataset.autoOpen !== 'false' && !hydration.dataset.scheduled &&
        Date.now() - Number(read('localStorage', hydrationKey) || 0) >= (Number(hydration.dataset.cooldown) || 7) * 86400000) {
      hydration.dataset.scheduled = 'true';
      schedule(hydration, hydrationKey);
    } else if (newsletter && !newsletter.dataset.scheduled && !hydration?.dataset.scheduled) {
      newsletter.dataset.scheduled = 'true';
      schedule(newsletter, 'rootix-drop-closed');
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-dialog]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.openDialog);
      if (dialog) { event.preventDefault(); open(dialog, trigger); }
    }
    const closeButton = event.target.closest('[data-dialog-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
  });
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', event => {
    const dialog = event.target.querySelector?.('[data-hydration-dialog]');
    if (dialog) open(dialog);
  });
})();
